import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import { IEmployee } from './typings'
import { StoreData } from '../reducers/typings'
import { getEmployee, getEmployeeList } from '.'

export const employeeAdapter = createEntityAdapter<IEmployee>({
  selectId: (employee) => employee.id,
  sortComparer: (a, b) => a.id.localeCompare(b.id),
})

export const initialState = employeeAdapter.getInitialState()

export const employees = createSlice({
  name: 'employeesState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getEmployeeList.fulfilled,
      (employeesState, { payload }) => {
        employeeAdapter.setAll(employeesState, payload)
      },
    )
    builder.addCase(getEmployee.fulfilled, (state, { payload }) => {
      employeeAdapter.upsertOne(state, payload)
    })
  },
})

export default employees.reducer

export const employeeAdapterSelectors = employeeAdapter.getSelectors<StoreData>(
  (storeState) => storeState.employeesState,
)

// employeeAdapterSelectors.selectTotal

export const { selectById: selectEmployeeById, selectAll: selectAllEmployees } =
  employeeAdapterSelectors
